/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                $(document).ready(function () {
                    //init wow animation
                    //new WOW().init();
                    //init ooltip
                    $('[rel="tooltip"]').tooltip();
                    //init FitVids
                    $(".oembed-container").fitVids();
                    // init LightGallery
                    $('[rel="lightGallery"]').lightGallery();

                    /**
                    * Determine the mobile operating system.
                    * This function either returns 'iOS', 'Android' or 'unknown'
                    *
                    * @returns {String}
                    */
                     function getMobileMessage() {
                      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                      if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
                      {
                        $('body').addClass('ios-device');
                        $('body .download-app').addClass('active');
                        $('body .download-app .ios-app-message').addClass('flex');
                        $('body .download-app .newsletter-message').addClass('flex');
                        $('.close').on('click', function () {
                          $(".text-sans-serif.download-app").css('display', 'none');
                        });
                      }
                      else if( userAgent.match( /Android/i ) )
                      {
                        $('body').addClass('android-device');
                        $('body .download-app').addClass('active');
                        $('body .download-app .android-app-message').addClass('flex');
                        $('body .download-app .newsletter-message').addClass('flex');
                         $('.close').on('click', function () {
                          $(".text-sans-serif.download-app").css('display', 'none');
                        });
                      }
                      else
                      {
                        $('body').addClass('show-newsletter');
                        /*$('body .download-app').addClass('active');*/
                      }
                    }
                    getMobileMessage();

                    //init lightslider for featured slider
                    var FeaturedSlider = $('[rel="lightSlider"]').lightSlider({
                        item: 1,
                        loop: true,
                        auto: true,
                        pause: 8000,
                        slideMargin: 10,
                        mode: 'fade',
                        keyPress: true,
                        enableDrag: false,
                        controls: false,
                        adaptiveHeight: true,
                        onSliderLoad: function (el) {
                            $('[rel="lightSlider"]').removeClass('cS-hidden');
                        },
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    enableDrag: true,
                                    controls: false,
                                }
                            }
                        ],
                    });

                    //init lightslider for galleries
                    var slider = $('[rel="lightSliderGallery"]').lightSlider({
                        gallery: true,
                        item: 1,
                        loop: true,
                        thumbItem: 7,
                        slideMargin: 10,
                        keyPress: true,
                        enableDrag: false,
                        controls: false,
                        currentPagerPosition: 'middle',
                        onSliderLoad: function (el) {
                            $('.lightSlider').removeClass('cS-hidden');
                            el.lightGallery({
                                selector: '[rel="lightSliderGallery"] .lslide',
                                exThumbImage: 'data-thumb'
                            });
                        },
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    enableDrag: true,
                                    controls: false,
                                    thumbItem: 4,
                                }
                            }
                        ],
                    });
                    $('#goToPrevSlide').click(function () {
                        slider.goToPrevSlide();
                    });
                    $('#goToNextSlide').click(function () {
                        slider.goToNextSlide();
                    });

                    // Archive page gallery posts slider
                    var archiveSlider = function () {
                        $('[rel="archiveSlider"]').lightSlider({
                            gallery: true,
                            item: 1,
                            loop: true,
                            thumbItem: 4,
                            slideMargin: 10,
                            keyPress: true,
                            enableDrag: false,
                            controls: false,
                            currentPagerPosition: 'middle',
                            galleryMargin: 5,
                            onSliderLoad: function (el) {
                                $('.lightSlider').removeClass('cS-hidden').removeAttr('rel');
                            },
                            responsive: [
                                {
                                    breakpoint: 480,
                                    settings: {
                                        enableDrag: true,
                                        controls: false,
                                    }
                                }
                            ]
                        });
                    };
                    // First time initiation of slider
                    archiveSlider();

                    //Video oEmbed ajax generation
                    $(".widget_videogallery .playlist > article").bind('click', function () {
                        var oembed_url = $(this).data('oembed-url');
                        $(".widget_videogallery .playlist > article").removeClass('active');
                        $(this).addClass('active');
                        $(".widget_videogallery .video-container .oembed-data").html('');
                        $(".widget_videogallery .video-container span").removeClass('hidden');
                        //console.log(oembed_url);

                        $.ajax({
                            type: "POST",
                            url: myAjax.ajaxurl,
                            data: {action: "load_oembed_ajax", oembed_url: oembed_url},
                            success: function (data) {
                                //console.log(data);
                                $(".widget_videogallery .video-container span").addClass('hidden');
                                $(".widget_videogallery .video-container .oembed-data").html(data);
                            }
                        });
                    });

                    // Archive listing video
                    $(".timeline").delegate("article [data-oembed-url]", 'click', function () {
                        var oembed_url = $(this).data('oembed-url');
                        var post_id = $(this).data('post-id');
                        //console.log(oembed_url);
                        $(this).addClass('video-container relative fixed-height-200').html('<span class="center-block"><i class="fa fa-lg fa-spinner fa-pulse"></i></span>');
                        //console.log(this);
                        $.ajax({
                            type: "POST",
                            url: myAjax.ajaxurl,
                            data: {action: "load_oembed_ajax", oembed_url: oembed_url},
                            success: function (html) {
                                var old_src = $(html).attr('src');
                                var auto_play_iframe = $(html).attr('src', old_src + '&autoplay=1');
                                //console.log(auto_play_iframe);
                                $('[data-post-id=' + post_id + ']').html(auto_play_iframe);
                                // autoplay youtube url
                                //var rendered_url = $('[data-post-id='+ post_id +'] iframe').attr('src');
                                //$('[data-post-id='+ post_id +'] iframe').attr('src', rendered_url+'&autoplay=1');
                            }
                        });
                    });

                    // Ajax load articles in archive pages
                    $('body').delegate('.more-archive','click', function () {
                        var $thisEl = $(this);
                        if (typeof archive_page === 'undefined') {
                            archive_page = $('.timeline').data('archive-page');
                        }
                        var max_num_pages = $('.timeline').data('max-page');

                        $.ajax({
                            url: myAjax.ajaxurl,
                            type: 'post',
                            data: {
                                action: 'ajax_pagination',
                                query_vars: myAjax.query_vars,
                                max_num_pages: max_num_pages,
                                page: archive_page
                            },
                            beforeSend: function () {
                                $thisEl.attr('disabled', 'disabled').append(' <i class="fa fa-fw fa-pulse fa-spinner"></i>');
                            },
                            success: function (html) {
                                var grid = document.querySelector('.timeline');
                                var fragment, items;
                                fragment = document.createElement("div");
                                fragment.innerHTML = html;
                                if (fragment.children.length !== 0) {
                                    items = Array.prototype.slice.call(fragment.children);
                                    salvattore.append_elements(grid, items);
                                    items.forEach(function (item) {
                                        return item;
                                    });
                                }
                                $thisEl.find('i').remove();

                                archiveSlider();
                                archive_page++;

                                // Push to browser history api
                                var archive_url_pattern = $('.pager .nav-links .next').attr('href');
                                var new_archive_url = archive_url_pattern.replace(/page\/[0-9]+\//, 'page/' + archive_page + '/');
                                console.log(archive_page);
                                var next_url = archive_url_pattern.replace(/page\/[0-9]+\//, 'page/' + (archive_page + 1) + '/');
                                $('.pager .nav-links .next').attr('href', next_url);

                                var prev_url = archive_url_pattern.replace(/page\/[0-9]+\//, 'page/' + (archive_page - 1) + '/');
                                $('.pager .nav-links .prev').attr('href', prev_url);

                                history.pushState(null, null, new_archive_url);

                                $('.timeline').attr('data-archive-page', archive_page);
                                if (archive_page >= max_num_pages) {
                                    $thisEl.remove();
                                    $('.end-section').removeClass('hidden');
                                }
                            },
                            complete: function () {
                                // Activate button for clicking
                                $thisEl.removeAttr('disabled');
                            }

                        });
                    });

                    // Header Search toggle fuctionality
                    $('header .navbar-form .search-toggle').on('click', function () {
                        $(this).addClass('hidden');
                        $('header .navbar-form .form-data').removeClass('hidden');
                        $('header .navbar-form').addClass('active');
                    });
                    $('header .navbar-form .form-data .search-toggle-close').on('click', function () {
                        $(this).parent().addClass('hidden').parent().removeClass('active');
                        $('header .navbar-form .search-toggle').removeClass('hidden');
                    });
                    //$('header .navbar-form .form-data input').on('blur', function () {
                    //    $(this).parent().addClass('hidden').parent().removeClass('active');
                    //    $('header .navbar-form .search-toggle').removeClass('hidden');
                    //});

                    //EGX Companies ticker
                    $('#webticker').webTicker({
                        speed: 50, //pixels per second
                        direction: "left", //if to move left or right
                        moving: true, //weather to start the ticker in a moving or static position
                        startEmpty: false, //weather to start with an empty or pre-filled ticker
                        duplicate: true, //if there is less items then visible on the ticker you can duplicate the items to make it continuous
                        updatetype: "swap" //how the update would occur options are "reset" or "swap"
                    });

                    // dataTable init
                    $('.datatable').DataTable({

                        //"lengthMenu": [[20, 50, 100, -1], [20, 50, 100, "الكل"]],
                        "paging": false,
                        "info": false,
                        "searching": false,
                        "order": [],
                        "columnDefs": [ {
                          "targets"  : 'no-sort',
                          "orderable": false,
                          "order": []
                        }],
                    });

                    // Sharing fuctionality
                    $('.social-sharer > a[data-network]').on('click', function () {
                        var title = $(this).data('title'),
                                url = $(this).data('url'),
                                image = $(this).data('image'),
                                $network = $(this).data('network'),
                                url_object = {
                                    facebook: 'https://facebook.com/sharer.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title),
                                    twitter: 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url) + '',
                                    linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title),
                                    googleplus: 'http://plus.google.com/share?url=' + encodeURIComponent(url),
                                    pinterest: 'http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&media=' + encodeURIComponent(image)
                                };
                        var width = 600, height = 300;
                        var leftPosition, topPosition;
                        leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
                        topPosition = (window.screen.height / 2) - ((height / 2) + 50);
                        var windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
                        window.open(url_object[$network], 'sharer', windowFeatures);
                        return false;
                    });

                    // breaking news socket
                    var socket = io.connect(myAjax.notification_url);
                    socket.on('urgent', function(obj){
                      //console.log("urgent",obj);
                      $('body').addClass('body-breaking-news');
                      $('.breaking-news h3 a').html(obj.title);
                      $('.breaking-news h3 a').attr('href',obj.url);
                      $('.breaking-news time').html(obj.time);
                      $('.breaking-news time').attr('datetime',obj.full_time);
                      //$('.breaking-news').removeClass('hidden');
                    });
                    socket.on('sleep', function(obj){
                      //console.log("sleep");
                      $('body').removeClass('body-breaking-news');
                      $('.breaking-news h3 a').html("");
                      $('.breaking-news h3 a').attr('href',"");
                      $('.breaking-news time').html("");
                      $('.breaking-news time').attr('datetime',"");
                      //$('.breaking-news').addClass('hidden');
                    });


                });// END $(document).ready
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
